var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{attrs:{"app":""}},[(!_vm.$vuetify.breakpoint.mobile)?_c('Home',{attrs:{"orders":_vm.orders},on:{"refresh":_vm.reloadOrders}}):_c('Mobile',{attrs:{"orders":_vm.orders},on:{"refresh":_vm.reloadOrders}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }